import React from 'react';

function AndroidIcon({ w, h, style, fill, className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={`${w}px`}
      height={`${h}px`}
      viewBox="0 0 24 24"
      className={className}
      style={style}
    >
      <path
        fill={fill}
        fillRule="evenodd"
        d="M6 5.7l6.2 6.2v.2L6 18.3a1 1 0 0 1-.3-.7V6.4c0-.3 0-.5.2-.7zm7.2 6.2l2.1-2 2.5 1.4c.7.4.7 1 0 1.4l-2.4 1.4-2.2-2v-.2zm-6.8 6.9l6.3-6.3 2.1 2.1-7.3 4.2c-.5.3-.8.2-1 0zm0-13.6A.6.6 0 0 1 7 5c.2 0 .4 0 .6.2l7.3 4.2-2 2-6.4-6.2z"
      />
    </svg>
  );
}

AndroidIcon.defaultProps = {
  w: 24,
  h: 24,
  style: {},
  fill: '#000',
};

export default AndroidIcon;
